import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import Text from '../../../../atoms/Text';

const cx = classNames.bind(styles);
interface TopHeaderProps {
  header: string;
  subHeader: string;
  deviceType: string;
}

const TopHeader = (props: TopHeaderProps): JSX.Element => {
  const { header = '', subHeader = '', deviceType = 'mobile' } = props;
  return (
    <div className={cx('header')}>
      <div className={cx('textConatiner', deviceType === 'desktop' && 'desktop-textContainer')}>
        <Text
          variant="T9"
          weight="bold"
          color="Nero"
          customClass={cx(deviceType === 'desktop' && 'custom-header')}
        >
          {header}
        </Text>
        <Text
          variant="T2"
          weight="regular"
          color="Dark_Grey"
          customClass={cx(deviceType === 'desktop' && 'custom-subHeader')}
        >
          {subHeader}
        </Text>
      </div>
      <div className={cx(deviceType === 'desktop' ? 'desktop-line' : 'line')} />
    </div>
  );
};

export default TopHeader;
